import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ContentSection() {
  const { t } = useTranslation();

  return (
    <section id="content" className="bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-grid-line text-sm" />
              {t("content.eyebrow")}
            </span>

            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {t("content.title")}
            </h2>

            <div className="mt-6 space-y-5 text-base leading-relaxed text-foreground-700">
              <p>{t("content.p1")}</p>
              <p>{t("content.p2")}</p>

              <h3 className="pt-2 font-heading text-xl font-semibold text-foreground-950">
                {t("content.sub1")}
              </h3>
              <p>{t("content.p3")}</p>

              <h3 className="pt-2 font-heading text-xl font-semibold text-foreground-950">
                {t("content.sub2")}
              </h3>
              <p>{t("content.p4")}</p>

              <h3 className="pt-2 font-heading text-xl font-semibold text-foreground-950">
                {t("content.sub3")}
              </h3>
              <p>{t("content.p5")}</p>
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="sticky top-24 rounded-lg border border-background-300/60 bg-background-50 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className="ri-book-open-line text-2xl" />
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {t("article.ctaTitle")}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {t("article.ctaText")}
              </p>
              <Link
                to="/article"
                className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                {t("article.ctaButton")}
                <i className="ri-arrow-right-line text-base" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}